import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import {FiAlertCircle} from "react-icons/fi";

const MissedCallPopup = () => {
	const [isShowing, setIsShowing] = useState(false);

    useEffect(() => {
        const misscallTimerValue = localStorage.getItem("misscallTimer");
        if (misscallTimerValue !== null && parseInt(misscallTimerValue, 10) >= 300000) {
            setIsShowing(true);
        }
    }, []);

    const handleClose = () => {
        setIsShowing(false);
    }

    return (
        <React.Fragment>
            {(isShowing) &&
				<Modal size="sm" show={isShowing} onHide={handleClose} backdrop="static" keyboard={false} centered>
					<Modal.Body>
						<div className='row'>
							<div className='col-12'>
								<div className='incomming-box text-center'>
									<div className='incomming-call-icon text-danger'><FiAlertCircle /></div>
									<h6 className='mt-3 mb-0 text-darkblue'>You have been on Missed Call status for over 5 minutes! Please change your status as soon as possible.</h6>
                                    <hr />
                                    <Button onClick={() => { handleClose() }} className='mw-100 me-2' variant="primary">
                                        OK, I will
                                    </Button>
                                </div>                    
							</div>
						</div>
					</Modal.Body>
				</Modal>
			}
        </React.Fragment>
    )
}
export default MissedCallPopup;